// src/EditProfilePage.js

import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Layout, Menu, Select, Modal } from 'antd';
import {
  DashboardOutlined,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { BrowserRouter as Router, Switch, Route, Link, useLocation  } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';

import { useNavigate } from 'react-router';
import Sidebar from '../../Side_Bar/Admin_Side_Bar.js';

import axios from 'axios'; // Import axios library
const { Option } = Select;

const { Sider, Content } = Layout;

const EditCustomerPage = () =>{
  const location = useLocation();
  const { username } = location.state || {};

  const mainUrl = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com";

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [form] = Form.useForm();


  const [isChangeOk, setIsChangeOk] = useState(false);
  const [isChangeNotOk, setIsChangeNotOk] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Define an asynchronous function to fetch data
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getCustomerWithUsername?username=${username}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        // Update the form data state with the fetched data
        setFormData({
          companyName: data[0].name,
          ssmNo: data[0].ssm_no,
          businessAddress: data[0].address,
          businessDescription: data[0].business_description,
          industry: data[0].industry,
          adminEmail: data[0].admin_email,
          financeEmail: data[0].finance_email,
          notificationEmail: data[0].notification_email,
          adminName: data[0].admin_name,
          adminContact: data[0].admin_contact_number,
          websiteURL: data[0].website_url,
          facebookProfile: data[0].facebook_profile_url,
          instagramProfile: data[0].instagram_profile_url,
          username: data[0].username,
        });

        setLoading(false);
        // Process the data as needed
      } catch (error) {
        console.error('Error fetching table data:', error);
        setLoading(false);
        // Handle the error
      }
    };
  
    // Invoke the asynchronous function
    fetchData();
  }, []); // Include dependencies if needed
  

  const onFinish = async (values) => {
    try {
      const updatedData = {
        username: values.username, // Make sure to include the customer ID in your form data
        name: values.companyName,
        ssmNo: values.ssmNo,
        address: values.businessAddress,
        businessDescription: values.businessDescription,
        industry: values.industry,
        adminEmail: values.adminEmail,
        financeEmail: values.financeEmail,
        notificationEmail: values.notificationEmail,
        adminName: values.adminName,
        adminContactNumber: values.adminContact,
        websiteURL: values.websiteURL,
        facebookProfileURL: values.facebookProfile,
        instagramProfileURL: values.instagramProfile,
      };
      
      console.log(updatedData)
      // Make the API call
      axios.put(mainUrl + `/updateCustomer`, updatedData)
      .then(response => {
        console.log('Updated Company Data', response.data);
        setIsChangeOk(true);
      })
      .catch(error => {
        setIsChangeNotOk(true);
        console.error('Error updating company cost:', error.response ? error.response.data : error.message);
      });

      } catch (error) {
        setIsChangeNotOk(true);
        console.error('Error updating customer:', error);
      }
  };


  const handleModalOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeOk(false);
    navigate('/view_edit_customer');
  };

  const handleModalNotOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeNotOk(false);
    navigate('/view_edit_customer');
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  const boxHeight = "50px";

  return (
    <Layout style={{ minHeight: '98vh' }}>
      <Sidebar location={location} />
          <Layout>
          <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>UPDATE COMPANY PROFILE</Title>
        <div style={{ maxWidth: "100%", margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
            <Form
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 16 }}
              onFinish={onFinish}
              initialValues={formData}
              onValuesChange={(changedValues) => {
                setFormData((prevData) => ({ ...prevData, ...changedValues }));
                }}
            >
              {/* Basic Information */}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                name="companyName"
                rules={[{ required: true, message: 'Please enter the name' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: "35%"}}
              >
                <Input 
                placeholder="Company Name"
                style={{ height: boxHeight, width: '300%' }} />
              </Form.Item>

              <Form.Item
                name="industry"
                rules={[{ required: true, message: 'Please select the industry' }]}
                style={{ fontSize: '16px', flex: '1' }}
              >
                <Select 
                placeholder="Company Industry"
                style={{ width: '150%', height: boxHeight }}
                >
                  <Option value="Retail">Retail</Option>
                  <Option value="Construction">Construction</Option>
                  <Option value="Transport">Transport</Option>
                  <Option value="Agriculture">Agriculture</Option>
                  <Option value="Manufacturing">Manufacturing</Option>
                  <Option value="F&B">F&B</Option>
                  <Option value="Pharmaceutical">Pharmaceutical</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="ssmNo"
                  rules={[{ required: true, message: 'Please enter the SSM No' }]}
                  style={{ fontSize: '16px', flex: '1'}}
                >
                  <Input 
                  placeholder = "Company SSM No"
                  style={{ height: boxHeight, width: '150%' }} />
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                    name="businessAddress"
                    rules={[{ required: true, message: 'Please enter the address' }]}
                    style={{ fontSize: '16px', flex: '1'}}
                  >
                    <Input 
                    placeholder = "Company Address"
                    style={{ height: boxHeight, width: '150%' }} />
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                    name="businessDescription"
                    rules={[{ required: true, message: 'Please enter the business description' }]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Input 
                    placeholder="Company Description"
                    style={{ height: boxHeight , width: '150%' }}/>
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                name="websiteURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: '2%' }}
              >
                <Input 
                placeholder="Website URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>

              <Form.Item
                name="facebookURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: '2%' }}
              >
                <Input 
                placeholder="Facebook URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>

              <Form.Item
                name="instagramURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1' }}
              >
                <Input 
                placeholder="Instagram URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>
            </div>
              {/* Contact and Logo */}
              <Title level={4} style={{marginTop: "10px"}}>Admin Details</Title>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminName"
                  rules={[{ required: true, message: 'Please enter the PIC name' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Name"
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminContact"
                  rules={[{ required: true, message: 'Please enter the PIC contact number' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Contact number"
                  style={{ height: boxHeight, width: '150%'  }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminEmail"
                  rules={[{ required: true, message: 'Please enter the PIC email' }]}
                  style={{ fontSize: '16px' , flex: '1'}}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%" }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="financeEmail"
                  rules={[{ required: true, message: 'Please enter the finance email' }]}
                  style={{ fontSize: '16px' , flex: '1'}}
                >
                  
                  <Input 
                  placeholder="Finance Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="notificationEmail"
                  rules={[{ required: true, message: 'Please enter the notification email' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Notifications Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please enter the username' }]}
                  style={{ fontSize: '16px' , flex: '1'}}
                >
                  <Input 
                  placeholder="Username"
                  style={{ height: boxHeight, width: "150%"}}
                  disabled/>
                </Form.Item>
            </div>
              {/* Submit Button */}
              <div style={{ flexWrap: 'wrap', position: 'fixed', right: 30}}>
                <Form.Item>
                <Button 
                type="primary" htmlType="submit" 
                style={{ height: boxHeight, background: "#00308F" }}>
                    UPDATE
                </Button>
                </Form.Item>
              </div>
            </Form>

            <Modal
              title="Comapny Profile Edited"
              visible={isChangeOk}
              onOk={handleModalOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

            <Modal
              title="Error Editing Company"
              visible={isChangeNotOk}
              onOk={handleModalNotOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

        </div>
          </Layout>
          </Layout>
          
  );
};

export default EditCustomerPage;